module.exports = __webpack_public_path__ + "media/images/scribe-workbook-small-f0935dec.png";